/* @refresh reload */

(window as any).onSuccess = (token: string) => {
    const form = document.createElement("form");
    form.setAttribute("method", "POST");
    form.setAttribute("action", `${window.location}`);
    const hidden = document.createElement("input");
    hidden.setAttribute("type", "hidden");
    hidden.setAttribute("id", "token");
    hidden.setAttribute("name", "token");
    hidden.setAttribute("value", token);
    form.append(hidden);
    document.body.append(form);
    form.submit();
}
